import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://narccheckai.com";
const HOME_DESC =
  "Analyze text message conversations with NarcCheck AI. Explore possible narcissistic behaviors, gaslighting, manipulation, and unhealthy communication patterns with AI-powered insights.";

const PAGES = {
  "/": { title: "NarcCheck AI | AI Narcissism & Text Message Analyzer", desc: HOME_DESC },
  "/privacy": {
    title: "Privacy Policy | NarcCheck AI",
    desc: "How NarcCheck AI collects, uses, and protects the conversations and account information you share with our AI narcissism analyzer.",
  },
  "/support": {
    title: "Support | NarcCheck AI",
    desc: "Get help with NarcCheck AI: contact support, manage or cancel your subscription, free trial and billing questions, and account help.",
  },
  "/terms": {
    title: "Terms of Service | NarcCheck AI",
    desc: "Terms of Service for NarcCheck AI, the AI-powered narcissist text message analyzer for personal reflection.",
  },
};

function setMeta(selector, attr, key, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute(selector.startsWith("link") ? "href" : "content", value);
}

// Per-route title, description, canonical and robots for the SPA.
export function SeoMeta() {
  const { pathname } = useLocation();
  useEffect(() => {
    const page = PAGES[pathname];
    document.title = page ? page.title : "NarcCheck AI";
    setMeta('meta[name="description"]', "name", "description", page ? page.desc : HOME_DESC);
    setMeta('meta[name="robots"]', "name", "robots", page ? "index, follow" : "noindex, nofollow");
    setMeta('link[rel="canonical"]', "rel", "canonical", `${SITE}${page ? pathname : "/"}`);
  }, [pathname]);
  return null;
}
